<template>
  <!-- <h4>Primary sponsor</h4>-->
  <!--<h4>Co-sponsors</h4>-->
  <div>
    <a href="https://www.biologists.com/" rel="nofollow">
      <img v-if="displayMode === 'lightMode'" src="./img/CoB.svg" alt="CoB" title="The Company of Biologists" />
      <img v-else src="./img/CoB-darkMode.svg" alt="CoB" title="The Company of Biologists" />
    </a>
    <a href="https://www.frontiersin.org/journals/bioinformatics" rel="nofollow">
      <img v-if="displayMode === 'lightMode'" id="frontiers" src="./img/frontiers.svg" alt="FBINF" title="Frontiers in Bioinformatics" />
      <img v-else id="frontiers" src="./img/frontiers-darkMode.svg" alt="FBINF" title="Frontiers in Bioinformatics" />
    </a>
  </div>
  <h4>Affiliations</h4>
  <div>
    <a href="https://www.embl.de/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/EMBL-lightMode.png"
        alt="EMBL"
        title="EMBL" />
      <img v-else src="./img/EMBL.png" alt="EMBL" title="EMBL" />
    </a>
    <a href="http://www.iscb.org/" rel="nofollow">
      <img src="./img/ISCB.jpeg" alt="ISCB" title="ISCB" />
    </a>
    <a href="https://www.eg.org/" rel="nofollow">
      <img v-if="displayMode === 'lightMode'" src="./img/EG.png" alt="Eurographics" title="Eurographics" />
      <img v-else src="./img/EG-darkMode.png" alt="Eurographics" title="Eurographics" />
    </a>
  </div>
  <h4>Media Partners</h4>
  <div>
    <a href="http://www.digizyme.com/" rel="nofollow">
      <img v-if="displayMode === 'lightMode'" src="./img/Digizyme.png" alt="Digizyme" title="Digizyme" />
      <img v-else src="./img/digizyme-darkMode.png" alt="Digizyme" title="Digizyme" />
    </a>
    <a href="https://www.embopress.org/journal/14693178">
      <img src="./img/EMBO-Reports.png" alt="EMBO Reports" title="EMBO Reports, an EMBO Press journal" />
    </a>
    <a href="https://iubmb.org/">
      <img src="./img/iubmb.jpeg" alt="IUBMB" title="International Union of Biochemistry and Molecular Biology" />
    </a>
    <a href="https://peerj.com/">
      <img src="./img/PeerJ.png" alt="PeerJ" title="PeerJ" />
    </a>
    <a href="http://rsob.royalsocietypublishing.org/">
      <img src="./img/rsob.png" alt="Open Biology" title="Open Biology, a Royal Society journal" class="openBiology" />
    </a>
  </div>
</template>

<script setup>
import {inject} from "vue";
const displayMode = inject("displayMode");
</script>

<style scoped>
img.openBiology {
  max-height: 35px;
}
img#frontiers {
  height: 2.3rem !important;
}
</style>
